module.exports = __webpack_public_path__ + "static/media/arcelik.9703b10e.svg";